var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.5C6.22386 20.5 6 20.2761 6 20L6 19C6 17.8954 6.89543 17 8 17C9.10457 17 10 17.8954 10 19V20C10 20.2761 9.77614 20.5 9.5 20.5M8 16.44V14M9 13.5L11.3598 15.4665C11.7307 15.7756 12.2693 15.7756 12.6402 15.4665L15 13.5M16 16.44V14M16.4995 5.5C16.4995 7.98528 14.4848 10 11.9995 10C9.51423 10 7.49951 7.98528 7.49951 5.5C7.49951 3.01472 9.51423 1 11.9995 1C14.4848 1 16.4995 3.01472 16.4995 5.5ZM2 22.8995C2.05391 17.423 6.51019 13 11.9995 13C17.4888 13 21.9451 17.423 21.999 22.8995C21.9996 22.9548 21.9547 23 21.8995 23H2.09951C2.04428 23 1.99946 22.9548 2 22.8995ZM18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17C17.1046 17 18 17.8954 18 19Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor2);
export default __webpack_public_path__ + "static/media/doctor-2.25594048a5ae8bd8c1674c7611bcb856.svg";
export { ForwardRef as ReactComponent };